class ReplaceLostShipmentController {
    static $inject = ["$q", "$location", "stToast", "tpsrService"];

    constructor($q, $location, stToast, tpsrService) {
        this.$q = $q;
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;

        this.order = null;
        this.shipment = null;
    }

    $onInit() {
        return this._loadOrder(this.orderId);
    }

    replacementTotalQuantity = () => this.shipment.lines.reduce((s, l) => s + l.replace_quantity, 0);

    createReplacementClicked = () => {
        const request = {
            user_id: this.order.user_id,
            is_replacement_bit: true,
            is_replacement_for_failed_to_deliver_bit: true,
            replacement_for_order_id: this.order.order_id,
            lines: []
        };
        this.shipment.lines.forEach(item => {
            if (item.replace_quantity > 0) {
                request.lines.push({
                    PIMS_item_id: item.PIMS_item_id,
                    Unit_Of_Measure: item.uom,
                    quantity: item.replace_quantity
                });
            }
        });

        return this.tpsr.createOrder(request).then(result => {
            if (result.success) {
                this.toast.success("Replacement Order Created", `Replacement Order created.`)
                this.$location.url(`/users/${this.order.user_id}/orders`);
            }
        });
    }

    cancelClicked = () => {
        this.$location.url(`/orders/${this.orderId}`);
    };

    _loadOrder = order_id => {
        return this.tpsr.getOrder(order_id).then(result => {
            this.order = result;
            this.shipment = this.order.shipments.find(s => s.PIMS_order_id === parseFloat(this.shipmentId));
            this.shipment.lines.forEach(l => {
                l.replace_quantity = l.quantity;
            });
        });
    };
}

angular
    .module("app")
    .component("replaceLostShipment", { // replace-lost-shipment
        bindings: {
            orderId: "<",
            shipmentId: "<"
        },
        templateUrl: "src/app/replaceLostShipment/replaceLostShipment.html",
        controller: ReplaceLostShipmentController
    });
